import React from 'react';
import Pagination from 'components/layout/pagination';
import PrintableFullReport from '../../components/printableFullReport';
import moment from 'moment';
import {formatCurrency, formatStaticCurrency} from 'helpers/currencyHelper';
import {dateTimeFormats} from 'helpers/constants';

import ReportApi from 'api/report';

import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

import events from 'lib/events';

class ReportSummary extends React.Component {
  state = {};

  analysisClick = (id, system) => {
    return `/#customer/${id}/${system}/report-history`;
  };

  customerClick = (id) => {
    return `/#customer/${id}`;
  };

  export = () => {
    let filters = this.props.filters;

    ReportApi.getWaterAnalysisAccountsExport(
      this.props.intl.locale,
      filters.dateFrom,
      filters.dateTo,
      filters.branch,
      filters.systemType,
    );
  };

  formatValue = (value, format) => {
    if (!value) {
      return '-';
    }
    return format ? format(value) : value;
  };


  printReport(data) {
    const {filters, tableData, POSActive} = this.props;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'reports.total.testing.accounts'}), key: 'TotalAccounts'},
      {name: formatMessage({id: 'general.active.accounts'}), key: 'ActiveAccounts'},
      {name: formatMessage({id: 'general.inactive.accounts'}), key: 'InactiveAccounts'},
      {name: formatMessage({id: 'general.total.pools'}), key: 'TotalPools'},
      {name: formatMessage({id: 'general.in.ground.pools'}), key: 'InGroundPools'},
      {name: formatMessage({id: 'general.above.ground.pools'}), key: 'AboveGroundPools'},
      {name: formatMessage({id: 'general.splasher.pools'}), key: 'SplasherPools'},
      {name: formatMessage({id: 'general.swim.spas'}), key: 'SwimSpas'},
      {name: formatMessage({id: 'general.spas'}), key: 'Spas'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'TotalMaintenanceSystems'},
      {name: formatMessage({id: 'general.total.analyses'}), key: 'TotalAnalyses'},
      {name: formatMessage({id: 'reports.average.analysis.account'}), key: 'AvgAnalysisPerAccount'},
    ];

    let posColumns = [
      {name: formatMessage({id: 'reports.average.purchase.account'}), key: 'AvgPurchasePerAccount'},
    ];

    data.AvgPurchasePerAccount = formatStaticCurrency(data.AvgPurchasePerAccount);

    const tableColumns = [
      {name: formatMessage({id: 'general.primary.contact'}), key: 'ContactName'},
      {
        name: formatMessage({id: 'reports.last.water.analysis'}), key: 'LastAnalysisSystem', format: function(i) {
          return moment(i, 'MMM D YYYY  h:mmA').format(dateTimeFormats.numeralDate);
        },
      },
      {name: formatMessage({id: 'reports.last.water.tester'}), key: 'LastWaterEmployeeTest'},
      {name: formatMessage({id: 'general.analyses'}), key: 'AnalysesCount', format: this.formatValue},
    ];

    const posTableColumns = [
      {name: formatMessage({id: 'general.purchase.last.purchase'}), key: 'LastBioGuardPurchase'},
      {
        name: formatMessage({id: 'reports.total.analyses.purchase'}),
        key: 'TotalAnalysesWithPurchase',
        format: this.formatValue,
      },
      {name: formatMessage({id: 'reports.total.purchases.analyses'}), key: 'TotalPurchases'},
    ];

    if (POSActive) {
      columns.push(...posColumns);
      tableColumns.push(...posTableColumns);
    }

    tableData.forEach((element) => {
      element.LastBioGuardPurchase = formatStaticCurrency(element.LastBioGuardPurchase);
      element.TotalPurchases = formatStaticCurrency(element.TotalPurchases);
    }, this);
    return (
      <PrintableFullReport
        end={moment(filters.dateFrom).format(dateTimeFormats.numeralDate)}
        endLabel={formatMessage({id: 'general.end.date'})}
        formatMessage={formatMessage}
        start={moment(filters.dateTo).format(dateTimeFormats.numeralDate)}
        startLabel={formatMessage({id: 'general.start.date'})}
        summaryColumns={columns}
        summaryData={data}
        tableColumns={tableColumns}
        tableData={tableData}
        title={formatMessage({id: 'general.water.analysis.accounts'})}
      />
    );
  };

  render() {
    let carts;
    let tableRows;
    let tableTitle;
    let data = this.props.data;
    let {formatMessage} = this.props.intl;

    if (data && Object.keys(data).length) {
      let summary = [
        {title: formatMessage({id: 'reports.total.testing.accounts'}), value: this.formatValue(data.TotalAccounts)},
        {title: formatMessage({id: 'general.active.accounts'}), value: this.formatValue(data.ActiveAccounts)},
        {title: formatMessage({id: 'general.inactive.accounts'}), value: this.formatValue(data.InactiveAccounts)},
        {title: '\u00A0', value: '\u00A0'},
        {title: formatMessage({id: 'general.total.pools'}), value: this.formatValue(data.TotalPools)},
        {title: formatMessage({id: 'general.in.ground.pools'}), value: this.formatValue(data.InGroundPools)},
        {title: formatMessage({id: 'general.above.ground.pools'}), value: this.formatValue(data.AboveGroundPools)},
        {title: formatMessage({id: 'general.splasher.pools'}), value: this.formatValue(data.SplasherPools)},
        {title: formatMessage({id: 'general.swim.spas'}), value: this.formatValue(data.SwimSpas)},
        {title: formatMessage({id: 'general.spas'}), value: this.formatValue(data.Spas)},
        {
          title: formatMessage({id: 'general.total.maintenance'}),
          value: this.formatValue(data.TotalMaintenanceSystems),
        },
        {title: '\u00A0', value: '\u00A0'},
        {title: formatMessage({id: 'general.total.analyses'}), value: this.formatValue(data.TotalAnalyses)},
        {
          title: formatMessage({id: 'reports.average.analysis.account'}),
          value: this.formatValue(data.AvgAnalysisPerAccount),
        },
      ];

      if (this.props.POSActive) {
        summary.push({
          title: formatMessage({id: 'reports.average.purchase.account'}),
          value: this.formatValue(data.AvgPurchasePerAccount, formatCurrency),
        });
      }

      carts = summary.map((cart, i) =>
        <div className="col-sm-3"
             key={i}>
          {cart.title} <br/>
          <span>{cart.value}</span>
        </div>,
      );

      tableRows = this.props.tableData.map((row, i) =>
        <tr key={i}
            className={i % 2 !== 0 ? 'gray-row' : ''}>
          <td><a href={this.customerClick(row.ContactID)}>{row.ContactName}</a></td>
          <td>
            <a href={this.analysisClick(row.ContactID, row.LastAnalysisSystem)}>{moment(row.LastWaterAnalysisDate).format(dateTimeFormats.numeralDate)}</a>
          </td>
          <td>{row.LastWaterEmployeeTest}</td>
          <td className="table-number">{this.formatValue(row.AnalysesCount)}</td>
          <td className={this.props.POSActive ? 'table-number' : 'not-show'}>{this.formatValue(row.LastBioGuardPurchase, formatCurrency)}</td>
          <td className={this.props.POSActive ? 'table-number' : 'not-show'}>{this.formatValue(row.TotalAnalysesWithPurchase)}</td>
          <td className={this.props.POSActive ? 'table-number' : 'not-show'}>{this.formatValue(row.TotalPurchases, formatCurrency)}</td>
        </tr>,
      );
    }

    return (
      <div>
        <div className="summary-container">
          <h2><FormattedMessage id="reports.report.summary"/></h2>
          <span className={Object.keys(data).length ? 'summary-date' : 'not-show'}> | <FormattedMessage id="general.date.range.labelled"
                                                                                                        values={{
                                                                                                          start: moment(this.props.filters.dateFrom)
                                                                                                            .format(dateTimeFormats.numeralDate),
                                                                                                          end: moment(this.props.filters.dateTo)
                                                                                                            .format(dateTimeFormats.numeralDate),
                                                                                                        }}/>
          </span>
          <br/>
          <span><FormattedMessage id="reports.reveal.report.summary"/></span>
          {this.props.showNoDataMessage ?
            <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
          <div className="container-fluid custom-container-margins">
            <div className={carts && Object.keys(carts).length ? 'row' : 'not-show'}
                 id="row-no-padding">
              {carts}
            </div>
            <div className={Object.keys(data).length ? 'row' : 'not-show'}
                 id="row-no-padding">
              <table className="summary-table">
                <tbody>
                  <tr className="table-title">
                    <th className="bigger-row"><FormattedMessage id="general.primary.contact"/></th>
                    <th><FormattedMessage id="reports.last.water.analysis"/></th>
                    <th><FormattedMessage id="reports.last.water.tester"/></th>
                    <th className="table-number"><FormattedMessage id="general.analyses"/></th>
                    <th className={this.props.POSActive ? 'table-number' : 'not-show'}>
                      <FormattedMessage id="general.purchase.last.purchase"/></th>
                    <th className={this.props.POSActive ? 'table-number' : 'not-show'}>
                      <FormattedMessage id="reports.total.analyses.purchase"/></th>
                    <th className={this.props.POSActive ? 'table-number' : 'not-show'}>
                      <FormattedMessage id="reports.total.purchases.analyses"/></th>
                  </tr>
                  {tableRows}
                </tbody>
              </table>
              <div className='center-pagination'>
                <Pagination
                  onPageChange={this.props.onPageChange}
                  page={this.props.page}
                  count={this.props.count}
                  total={this.props.total}/>
              </div>
            </div>
          </div>
        </div>
        <div className='col-sm-12 button-group'>
          <button className='btn btn-default pull-right'
                  disabled={Object.keys(data).length <= 0}
                  onClick={(() => {
                    events.publish('print', this.printReport(this.props.data));
                  })}><FormattedMessage id="reports.print.summary"/></button>
          <button className='btn btn-primary pull-right'
                  onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
        </div>
      </div>
    );
  }
}

export default injectIntl(ReportSummary);
